import { render, staticRenderFns } from "./refundRecord_gr.vue?vue&type=template&id=0190a60c&scoped=true&"
import script from "./refundRecord_gr.vue?vue&type=script&lang=js&"
export * from "./refundRecord_gr.vue?vue&type=script&lang=js&"
import style0 from "./refundRecord_gr.vue?vue&type=style&index=0&id=0190a60c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0190a60c",
  null
  
)

export default component.exports